import _ from 'underscore';
import $ from 'jquery';
// import gmaps from 'googleapis';
import Util from 'views/utils/LeafletMap/utils/Util';
import DirectionService from 'views/utils/LeafletMap/MapServices/DirectionService';

var TransitModeMapping = {
    CYCLING: 'BICYCLING',
    PEDESTRIAN: 'WALKING'
};

var GoogleDirectionService = function(args) {
    DirectionService.call(this, args);

    this.directionService = new google.maps.DirectionsService();
    this.retryCount = 0;

    return this;
};

GoogleDirectionService.prototype = Object.create(DirectionService.prototype);
GoogleDirectionService.prototype.constructor = GoogleDirectionService;

// for solving google map didn't support bike mode by using direction service
GoogleDirectionService.prototype.retryCountSet = function retryCountSet() {
    this.retryCount = 0;
};

GoogleDirectionService.prototype.fetch = function fetch(options, context) {
    var transitMode = google.maps.TravelMode.WALKING,
        that = this,
        start = new google.maps.LatLng(options.start[0], options.start[1]),
        finish = new google.maps.LatLng(options.end[0], options.end[1]);

    if (TransitModeMapping[this.transitMode]) {
        transitMode = TransitModeMapping[this.transitMode];
    }

    var directionRequest = {
        origin: start,
        destination: finish,
        travelMode: transitMode,
        provideRouteAlternatives: false,
        avoidHighways: true,
        avoidTolls: true
    };

    if (options.isMetric) {
        directionRequest.unitSystem = google.maps.UnitSystem.METRIC;
    } else {
        directionRequest.unitSystem = google.maps.UnitSystem.IMPERIAL;
    }

    this.directionService.route(directionRequest, function(response, status) {
        if (status === google.maps.DirectionsStatus.OK) {
            var directionsRoute = response.routes[0];
            var meters = 0;
            for (var x = 0; x < directionsRoute.legs.length; x++) {
                meters += directionsRoute.legs[x].distance.value;
            }
            var points = [];
            $.each(directionsRoute.overview_path, function(i, point) {
                points.push([point.lat(), point.lng(), 0, 0]);
            });

            that.errorCount = 0;

            options.success.call(context, { points: points, meters: meters });
        } else {
            if (transitMode === TransitModeMapping.CYCLING && that.retryCount == 0) {
                // Certain placed outside of the US will error if the transitMode is CYCLING
                that.transitMode = Util.TRANSIT_MODE.PEDESTRIAN;
                that.retryCount++;
                that.fetch(options, context); // lets try again.
            } else {
                options.error.call(context, status, status, Util.ErrorCodes.GENERIC); // Google doesn't return any message if error
            }
        }
    });
};

export default GoogleDirectionService;
